import { render } from "./tabs.vue?vue&type=template&id=c1d6c2e4&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=c1d6c2e4&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d6c2e4"]])

export default __exports__